<!-- =========================================================================================
    File Name: ProgramItem.vue
    Description: Элемент партнерской программы
========================================================================================== -->


<template>
    <div @click="displayPrompt" class="px-4 py-4 list-item-component">
        <div class="vx-row">
            <div class="vx-col w-full sm:w-5/6 flex sm:items-center sm:flex-row flex-col">
                <div class="flex items-center">
                    <h6 class="program-name" :class="{'line-through': programLocal.isCompleted}">{{ programLocal.ppid }}. {{ programLocal.name }}</h6>
                </div>
                <div class="program-state sm:ml-2 sm:my-0 my-2 flex">
                  <vs-chip :key="programLocal.state">
                      <div class="h-2 w-2 rounded-full mr-1" :class="'bg-' + programStateList[programLocal.state].color"></div>
                      <span>{{ programStateList[programLocal.state].label }}</span>
                  </vs-chip>
                </div>
            </div>
        </div>
        <div class="vx-row" v-if="programLocal.descr">
            <div class="vx-col w-full">
                <p class="mt-2 truncate">{{ programLocal.descr }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import modulePartner          from '@/store/partner/modulePartner.js'

export default{
    props: {
        programId: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
          programLocal: this.$store.getters["partner/getProgram"](this.programId),
          programStateList: modulePartner.programStateList
        }
    },
    computed: {
    },
    methods: {
        displayPrompt() {
          this.$emit('showDisplayPrompt', this.programId)
        }
    },
}
</script>
